import styled, { css } from 'styled-components';
import { breakpoints } from '../../../shared/utils/styles';

const getMediaOrPopoutCommentGridArea = (openPopoutComment) => (openPopoutComment ? 'popoutComments' : 'media');

export const Layout = styled.div`
  ${({ openPopoutComment }) => css`
    display: grid;
    height: 100vh;
    /* grid-template-rows: 50px .5fr .75fr 0.5fr 2.25fr 0.7fr 1fr .5fr 2fr; */
    grid-template-rows: 50px .5fr .5fr 0.5fr .75fr 2.25fr 1.5fr 1fr .5fr .5fr 2.5fr;
    grid-template-columns: 50px minmax(235px, .4fr) 1fr minmax(325px, 375px);
    @media (max-width: ${breakpoints.auctioneer.small}) {
      grid-template-rows: 50px .5fr .25fr 0.25fr .5fr 2.25fr 1.5fr 1fr 0fr 0fr 3fr;
      grid-template-columns: 50px minmax(300px, .4fr) 1fr minmax(300px, 375px);
    }
    grid-template-areas:
      'snav tbar tbar tbar'
      'snav laneStatus lotNumber messages'
      'snav reserveAmt itemName messages'
      'snav reserveAmt seller-actions messages'
      'snav reserveAmt amount messages'
      'snav details amount messages'
      'snav details amount bid-activity'
      'snav details status bid-activity'
      'snav comments ${getMediaOrPopoutCommentGridArea(openPopoutComment)} bid-activity'
      'snav comments ${getMediaOrPopoutCommentGridArea(openPopoutComment)} bid-activity'
      'snav comments ${getMediaOrPopoutCommentGridArea(openPopoutComment)} prevDecision';
    grid-gap: 2px;
    overflow-y: scroll;
    /* overflow-x: hidden; */
    & > div:not(:first-child) {
      border: 1px solid gray;
    }
    & .blockStatus {
      & h2 {
        font-size: min(2vw, 3em);
        font-weight: bold;
      }
    }  
  `};
`;

export default Layout;
